import { StyleSheet } from "aphrodite";


export default StyleSheet.create({
    centerContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
    },
      smallPadding: {
        padding: "20px"
      },
      text: {
        textAlign: "center",
      },
      backDrop: {
        position: "fixed",
        color: "#fff",
        zIndex: 0,
        width: "100%",
        height: "100%",
        top: 0,
        left: 0,
    },
});